import React from 'react';
import styles from './Title.module.css';

const TitleSecondary = ({ text, style }) => {
    return (
        <h2 className={styles.secondaryTitle} style={style}>
            <span>{text}</span>
        </h2>
    );
};

export default TitleSecondary;
